import axios from 'axios';
import {
    getAuthHeader
} from "@/services/user.service.js";

export {
    GetAllVariables,
    SaveVariable,
    CreateNewVariable,
    DeleteVariable
};

function GetAllVariables(contractId, versionId, editionId, onSuccess, onError){
    
    var headers = getAuthHeader();
    axios
        .get(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/variables`, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function SaveVariable(contractId, versionId, editionId, variableObject, onSuccess, onError){
    
    var headers = getAuthHeader();
    axios
        .put(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/variables`, variableObject, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function DeleteVariable(contractId, versionId, editionId, variableToBeDeletedId, onSuccess, onError){
    
    var headers = getAuthHeader();
    axios
        .delete(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/variables/${variableToBeDeletedId}`, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function CreateNewVariable(contractId, versionId, editionId, variableObject, onSuccess, onError){
    var headers = getAuthHeader();
    axios
        .post(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/variables`, variableObject, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}
